<template lang="pug">
v-card.elevation-1.pa-2(:color="actividad.oculto ? 'secondary primary--text' : ''" :dark="actividad.oculto === 1" max-width="500")
  v-dialog(
    v-model='isModalEliminarActividad'
    width="450",
    @click:outside="closeModalEliminarActividad()"
    transition='dialog-bottom-transition'
  )
    v-card.pa-2
      h1.text-center.font-weight-700.font-size-20.py-4 ¿Estas seguro que deseas eliminar esta actividad?
      .pa-4
        v-textarea(
          hide-details,
          autofocus
          ref="comentarioParaEliminarActividad"
          v-model='comentarioParaEliminarActividad'
          placeholder='Describe un motivo por el cual deseas eliminar la actividad'
          color="primary"
          solo
          dense,
          rows="6"
        )
      v-card-actions
        v-spacer
        v-btn(color='primary'  v-if="!isMovil" text='' small @click="closeModalEliminarActividad()")
          | Cancelar
        v-btn(color='primary' :block="isMovil" :small="!isMovil" @click="fetchEliminarActividad()")
          | Eliminar actividad
  v-dialog(
    v-model='showImageFull',
    transition='dialog-bottom-transition'
    :fullscreen="true",
    @click:outside="closeDialogImage()"
  )
    v-card.overflow-hidden(v-if="imagePreview")
      v-card.elevation-0(:height="isMovil ? `calc(100vh - ${!imagePreview.group ? '225px' : '170px'})` : `calc(100vh - ${!imagePreview.group ? '160px' : '100px'})`")
        v-img.background-filter.position-relative( :style="`-webkit-transform: rotate(${rotateDeg}deg);`" :src="imagePreview.contenido",)
        .box-preview-image.d-flex.jc-center.ai-center
          v-img.text-end(
            :style="`-webkit-transform: rotate(${rotateDeg}deg);`"
            :src="imagePreview.contenido",
            :height="isMovil ? 400 : 780"
            contain
          )
          .d-flex.rotates.ai-center.jc-center
            .ma-1.ml-8
              v-btn(color='primary' dark='' fab='', @click="rotateImage")
                v-icon rotate_90_degrees_ccw
              small.font-weight-700.ml-2 {{rotateDeg}}°
            v-menu(bottom='' origin='center center' transition='scale-transition')
              template(v-slot:activator='{ on, attrs }')
                v-btn.mx-4(icon   v-bind='attrs' v-on='on'  small, v-if="!actividad.oculto && perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario' && actividad.origen === 'empresa'")
                  v-icon more_vert
              v-list.py-0(dense)
                v-list-item(@click="openModalEliminarActividad()")
                  v-list-item-avatar
                    v-icon.grey.lighten-1(dark='' size="20")
                      | delete_sweep
                  v-list-item-title Eliminar esta actividad
          .d-flex.return(v-if="!isMovil")
            v-btn.ma-1(color='primary' dark='' fab='', @click="closeDialogImage()")
              v-icon arrow_back
      .d-flex.jc-center.ai-center
        v-slide-group(active-class='success' show-arrows='')
          v-slide-item(v-for='(n, index) in isGroupImagenes' :key='index' v-slot='{ active, toggle }')
            v-card.ma-1(hover @click="seleccionarImagen(index)" :class="{'border' : indexGroupItem === index}")
              v-img(:src="n.contenido"  height="55" width="55" contain)
      v-list(two-line='')
        v-list-item
          v-list-item-avatar
            v-avatar
              avatar-perfil(:is-fetch="true", :usuario="imagePreview.usuario")
          v-list-item-content
            v-list-item-title.font-weight-700(v-text='imagePreview.nombre')
            v-list-item-subtitle.font-size-12(v-text='imagePreview.fechaLegible')
          v-list-item-action
            .d-flex
              v-btn(fab color="primary" :href="imagePreview.contenido" target="_blanck" small)
                v-icon fullscreen
              v-btn.ml-3(fab color="success white--text" @click="descargarImagen(imagePreview.contenido, imagePreview.nombreAdjunto)" small)
                v-icon arrow_downward
      v-card-actions.pa-4(v-if="isMovil")
        v-btn(color='primary' block @click="closeDialogImage()" )
          | cerrar
  .d-flex(v-if="!actividad.oculto")
    .fd-column.d-flex
      small.font-size-12.font-weight-700  {{actividad.nombre}}
      small.font-size-11  {{actividad.cargo}}
    v-spacer
    v-menu(bottom='' origin='center center' transition='scale-transition')
      template(v-slot:activator='{ on, attrs }')
        v-btn(icon color="grey"  v-bind='attrs' v-on='on'  small, v-if="!actividad.group && !actividad.oculto && perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario' && actividad.origen === 'empresa'")
          v-icon more_vert
      v-list.py-0(dense)
        v-list-item(@click="openModalEliminarActividad()")
          v-list-item-avatar
            v-icon.grey.lighten-1(dark='' size="20")
              | delete_sweep
          v-list-item-title Eliminar esta actividad
  div
    div(v-if="actividad.oculto")
      v-icon(color="primary", size="18") do_not_disturb
      span.font-size-11.font-italic &nbsp; Esta actividad fue eliminada : &nbsp;
        span.font-weight-700 "{{actividad.mensajeOculto}}"
    div(v-else)
      template(v-if="actividad.tipo === 'adjunto'")
        span.font-size-11.grey--text {{actividad.accion | capitalize}}
        div(v-if="actividad.tipoAdjunto === 'image/png' || actividad.tipoAdjunto === 'image/jpg' || actividad.tipoAdjunto === 'image/jpeg'")
          v-card.mt-1.elevation-1(
            v-if="!actividad.group"
            max-height="230"
            @click="showDialogImage(false, 0, actividad)",
          )
            v-img(

              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1),#161f2b85"
              :src="actividad.contenido",
              max-height="150"
              content
            )
              v-btn.position-get(fab color="success white--text" @click.stop="descargarImagen(imagePreview.contenido, imagePreview.nombreAdjunto)" x-small)
                v-icon arrow_downward
              .d-flex
                v-spacer
                small.px-4.py-2.font-size-10.text-muted {{actividad.nombreAdjunto}}
          v-card.elevation-0(v-else)
            v-row(dense)
              v-col(cols="12" md='6', v-if="actividad.render1")
                v-card(@click="showDialogImage(true, 0, actividad.imagenes)")
                  v-img(
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1),#161f2b85"
                    :src="actividad.imagenes[0].contenido",
                    max-height="150"
                    height="110"
                    content
                  )
                    .d-flex
                      v-spacer
                      small.px-2.py-2.font-size-10.text-muted {{actividad.imagenes[0].nombreAdjunto}}
              v-col(cols="12" md='6' v-if="actividad.render2")
                v-card(@click="showDialogImage(true, 1, actividad.imagenes)")
                  v-img(
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1),#161f2b85"
                    :src="actividad.imagenes[1].contenido",
                    max-height="150"
                    height="110"
                    content
                  )
                    .d-flex
                      v-spacer
                      small.px-2.py-2.font-size-10.text-muted {{actividad.imagenes[1].nombreAdjunto}}
              v-col(cols="12" md='6' v-if="actividad.render3")
                v-card(@click="showDialogImage(true, 2, actividad.imagenes)")
                  v-img(
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1),#161f2b85"
                    :src="actividad.imagenes[2].contenido",
                    max-height="150"
                    height="110"
                    content
                  )
                    .d-flex
                      v-spacer
                      small.px-2.py-2.font-size-10.text-muted {{actividad.imagenes[2].nombreAdjunto}}
              v-col(cols="12" md='6' v-if="actividad.render4")
                v-card(@click="showDialogImage(true, 3, actividad.imagenes)")
                  v-img(
                    class="white--text align-end"
                    :gradient="actividad.countMore ? 'to bottom, #000000a8, #161f2b' : 'to bottom, rgba(0,0,0,.1),#161f2b85'"
                    :src="actividad.imagenes[3].contenido",
                    max-height="150"
                    height="110"
                    content
                  )
                    .d-flex(:class="{'' : actividad.countMore}")
                      v-spacer(v-if="!actividad.countMore")
                      .px-4.py-4(v-if="actividad.countMore")
                        span.font-size-30.font-weight-700 + {{actividad.countMore}}
                      small.px-4.py-2.font-size-11.text-muted(v-else) {{actividad.imagenes[3].nombreAdjunto}}

        v-card.mt-2.elevation-0(height="100%" v-else-if="actividad.tipoAdjunto === 'video/mp4'")
          video(width='100%'  height="100%" controls='')
            source(:src='actividad.contenido' type='video/mp4')
        v-card.mt-1.elevation-0(v-else)
          v-divider.pa-0.ma-0
          v-list.py-0(two-line='', dense,  :color="actividad.origen !== 'empresa' ? '' : ''")
            v-list-item.px-2(@click="() => {}")
              v-list-item-action.mr-3
                img(src="../../static/img/icons-actividad/pdf.png", width="45", v-if="actividad.tipoAdjunto === 'application/pdf'")
                img(src="../../static/img/icons-actividad/txt.png", width="45", v-else-if="actividad.tipoAdjunto === 'text/plain'")
                img(src="../../static/img/icons-actividad/exe.png", width="45", v-else-if="actividad.tipoAdjunto === 'application/x-msdownload'")
                img(src="../../static/img/icons-actividad/zip.png", width="45", v-else-if="actividad.tipoAdjunto === 'application/x-zip-compressed'")
                img(src="../../static/img/icons-actividad/xls.png", width="45", v-else-if="actividad.tipoAdjunto === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'")
                img(src="../../static/img/icons-actividad/doc.png", width="45", v-else-if="actividad.tipoAdjunto === 'application/msword' || actividad.tipoAdjunto === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'")
                img(src="../../static/img/icons-actividad/search.png", width="45", v-else)
              v-list-item-content
                v-list-item-title.font-size-12(v-text='actividad.nombreAdjunto')
                v-list-item-subtitle.font-size-11(v-text='actividad.tipoAdjunto')
              v-list-item-action
                v-btn(fab, x-small color="success", :href="actividad.contenido", target="_blanck")
                  v-icon arrow_downward
      template(v-if="actividad.tipo === 'cambio'")
        span.font-size-11.grey--text {{actividad.accion}}
        v-card.pa-3.elevation-0(color="#fb8c0021", v-if="actividad.comentario")
          .font-size-11.font-italic.warning--text {{`"${actividad.comentario}"`}}
        div(v-for="(a, e, i) in JSON.parse(actividad.contenido)")
          v-list-item.px-0
            v-list-item-content.py-1
              v-list-item-title.font-size-12.font-weight-700 {{e | capitalize}}
              .font-size-11.font-weight-700.white-space-none
                .d-flex(:class="{'fd-column' : isMovil, 'jc-center ai-center' :  !isMovil}")
                  span.primary--text {{a[0]}}
                  v-spacer( v-if="!isMovil")
                  v-icon.px-2(color="background", size="18" v-if="!isMovil") east
                  v-spacer( v-if="!isMovil")
                  span.success--text  {{a[1]}}
          v-divider.pa-0.ma-0(v-if='i < Object.keys(JSON.parse(actividad.contenido)).length - 1')
      template(v-if="actividad.tipo === 'cita'")
        span.font-size-11.grey--text {{actividad.accion}}
        v-card.elevation-1
          div(v-for="(a, e, i) in JSON.parse(actividad.contenido)")
            v-list-item.px-0
              v-list-item-content.py-1
                v-list-item-title.font-size-12.font-weight-700 {{e | capitalize}}
                .font-size-11.font-weight-700.white-space-none
                  .d-flex(:class="{'fd-column' : isMovil, 'jc-center ai-center' :  !isMovil}")
                    span.primary--text {{a[0]}}
                    v-spacer( v-if="!isMovil")
                    v-icon.px-2(color="background", size="18" v-if="!isMovil") east
                    v-spacer( v-if="!isMovil")
                    span.success--text  {{a[1]}}
            v-divider.pa-0.ma-0(v-if='i < Object.keys(JSON.parse(actividad.contenido)).length - 1')
          v-list.py-1(subheader='' dense, color="background" dark, v-if="!actividad.comentario")
            v-list-item
              v-icon.mr-2( color="grey", size="35")
                | insert_invitation
              v-list-item-content
                v-list-item-subtitle.grey--text.font-size-11 Cita programada para el
                v-list-item-title.font-size-16.font-weight-700.primary--text {{actividad.tipoAdjunto}}
              v-list-item-action(v-if="isLog")
                v-btn(fab x-small color="info white--text" @click="show = !show")
                  v-icon {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              v-list-item-action(v-if="!isLog && perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario'")
                v-btn(fab x-small color="primary white--text" @click="goTo(`/programacion/citas/${actividad.nombreAdjunto}`)" :disabled="perfilUsuario === 'supervisor'")
                  v-icon north_east
          v-list.py-1(subheader='' dense, color="secondary ", v-else)
            v-list-item
              v-icon.mr-2( color="primary", size="35")
                | event_busy
              v-list-item-content
                v-list-item-subtitle.primary--text.font-size-12 La cita programada fue cancelada
              v-list-item-action(v-if="isLog")
                v-btn(fab x-small color="info white--text" @click="show = !show")
                  v-icon {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          v-card.pa-3.elevation-0(color="#fb8c0021", v-if="actividad.comentario")
            .font-size-11.font-italic.warning--text {{`"${actividad.comentario}"`}}
          v-expand-transition
            div(v-show='show')
              v-card-text.py-1.px-2
                div(v-for="(a, e, i) in JSON.parse(actividad.contenido)")
                  v-list-item.px-0
                    v-list-item-content.py-1
                      v-list-item-title.font-size-12.font-weight-700 {{e | capitalize}}
                      .font-size-11.font-weight-700.white-space-none
                        .d-flex(:class="{'fd-column' : isMovil, 'jc-center ai-center' :  !isMovil}")
                          span.primary--text {{a[0]}}
                          v-spacer( v-if="!isMovil")
                          v-icon.px-2(color="background", size="18" v-if="!isMovil") east
                          v-spacer( v-if="!isMovil")
                          span.success--text  {{a[1]}}
      template(v-if="actividad.tipo === null || actividad.tipo === ''")
        span.font-size-11.grey--text {{actividad.accion | capitalize}}
        v-card.pa-3.elevation-0(color="#fb8c0021", v-if="actividad.comentario")
          .font-size-11.font-italic.warning--text
            span(v-for="(m, index) in returFormatComentario(actividad.comentario)")
              span(v-if="m") {{m}}
                br
      .d-flex.mt-1(v-if="isMovil")
        v-spacer
        small.font-size-10.text-muted {{actividad.fechaLegible}}
</template>
<script>
import avatarPerfil from '@/components/c_avatar_perfil'
import moment from 'moment'
import { apiDelete, notify } from '../util/general'
export default {
  props : {
    actividad : {
      type : Object
    },
    isLog : {
      type   : Boolean,
      default: false
    },
    group : {
      type : Boolean,
      default : false
    }
  },
  components: {
    'avatar-perfil': avatarPerfil
  },
  data () {
    return {
      showImageFull                  : false,
      imagePreview                   : {},
      rotateDeg                      : 0,
      show                           : false,
      perfilUsuario                  : localStorage.getItem('perfil'),
      isModalEliminarActividad       : false,
      comentarioParaEliminarActividad: '',
      isGroupImagenes                : [],
      indexGroupItem                 : ''
    }
  },
  filters : {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    fecha: function (value) {
      return moment.utc(value).format('DD/MM/YYYY HH:MM')
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    updatedList () {
      var vm = this
      vm.$emit('update')
    },
    fetchEliminarActividad () {
      var vm = this
      if (!vm.comentarioParaEliminarActividad) {
        notify(vm, 'error', 'Error', 'Ingrese un motivo por el cual deseas elimianr la actividad ')
        vm.$refs.comentarioParaEliminarActividad.focus()
        return
      }

      var obj = {
        codigo: vm.group ? vm.imagePreview.id : vm.actividad.id,
        motivo: vm.comentarioParaEliminarActividad
      }

      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Eliminando actividad' })
      apiDelete(vm, '/ticket/eliminar/actividad', obj, function (data) {
        notify(vm, 'success', 'Exito', 'La actividad se eliminó correctamente')
        if (vm.group) {
          vm.showImageFull = false
        }
        vm.closeModalEliminarActividad()
        vm.updatedList()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    goTo (page) {
      var vm = this
      if (vm.perfilUsuario === 'usuario-contrato' || vm.perfilUsuario === 'usuario') {
        window.open(page, '_blank')
        // Router.push(page)
      } else {
        window.open(page, '_blank')
        // RouterDispatcher.push(page)
      }
    },
    returFormatComentario (comentario) {
      return comentario.split('/br*')
    },
    openModalEliminarActividad () {
      var vm = this
      vm.isModalEliminarActividad = true
      vm.comentarioParaEliminarActividad = ''
    },
    closeModalEliminarActividad () {
      var vm = this
      vm.isModalEliminarActividad = false
      vm.comentarioParaEliminarActividad = ''
    },
    rotateImage () {
      var vm = this
      if (vm.rotateDeg === 360) vm.rotateDeg = 0
      else {
        vm.rotateDeg = vm.rotateDeg + 90
      }
    },
    showDialogImage (isGroupItem = false, position, item) {
      var vm = this
      console.log('isGroupItem', isGroupItem)
      console.log('position', position)
      console.log('item', item)
      console.log('vm.isGroupImagenes[position]', vm.isGroupImagenes[position])
      vm.showImageFull = false
      if (isGroupItem) {
        vm.indexGroupItem  = position
        vm.isGroupImagenes = item
        vm.imagePreview    = vm.isGroupImagenes[position]
        vm.showImageFull   = true
      } else {
        vm.isGroupImagenes = []
        vm.indexGroupItem = ''
        vm.imagePreview = item
        vm.showImageFull = true
      }
    },
    seleccionarImagen (index) {
      var vm = this
      vm.indexGroupItem  = index
      vm.imagePreview    = vm.isGroupImagenes[index]
    },
    closeDialogImage () {
      var vm = this
      vm.showImageFull = false
      vm.imagePreview = {}
      vm.rotateDeg = 0
    },
    descargarImagen (urlImage, name) {
      fetch(urlImage)
        .then(resp => resp.blob())
        .then(blob => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => notify('error', 'Error', 'Ocurrio un error al intentar descargar el archivo'));
    }
  }
}
</script>
<style lang="stylus" scoped>
.border
  border 2px solid red !important
.position-get
  position: absolute;
  top: 10px;
  right: 10px;
.rotates
  position absolute
  top -4px
  right 25px
.return
  position absolute
  top -25px
  left 25px
.position-more
  top 20px !important
  left 30px
</style>




// WEBPACK FOOTER //
// c_item_timeline.vue?313d87cc